import routerOptions0 from "/var/www/projects/hillceramic.se/releases/20261105081705Z/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/var/www/projects/hillceramic.se/releases/20261105081705Z/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}